<template>
  <div 
    :style="'height:' + options.height + 'px'" 
    v-html="options.content" 
    class="readonly-text">
  </div>
</template>

<script>
export default { 
  name: 'ReadonlyField',
  props: {
    options: {
      type: Object,
      required: true
    }
  }
}
  
</script>
